import React from 'react';
import PropTypes from 'prop-types';
import css from './SuccessMessage.css';
import Icon from 'SF/MaterialIcon';

export default class SuccessMessage extends React.Component {

  render() {
    return (
      <div className={css['container']} data-role="successMessageContainer">
        <div><Icon aria-hidden="true" icon="mood"/> {this.props.message}</div>
        <div
          onClick={this.props.onDismiss}
          aria-label="Dismiss"
          role="button"
          tabIndex="0">
          <Icon icon="close" />
        </div>
      </div>
    );
  }
}

SuccessMessage.propTypes = {
  message: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired
};
